import { render, staticRenderFns } from "./NieuwsmakerPresentationSlide.vue?vue&type=template&id=4d8f6d33"
import script from "./NieuwsmakerPresentationSlide.vue?vue&type=script&lang=js"
export * from "./NieuwsmakerPresentationSlide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports